<script setup lang="ts">
import SvgIcon from "~/components/Common/SvgIcon.vue";

const props = withDefaults(
  defineProps<{
    text?: string;
    size?: number;
  }>(),
  {
    text: "Chargement...",
    size: 32,
  },
);

const iconStyle = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
}));
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-3">
    <SvgIcon name="loader" class="animate-spin text-primary-blue-color" :style="iconStyle" />
    <span class="body_regular text-secondary-color">{{ text }}</span>
  </div>
</template>
